/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CategoryGetAllResp } from '../models/category-get-all-resp';
import { CategoryPublicGetResp } from '../models/category-public-get-resp';

@Injectable({
  providedIn: 'root',
})
export class CategoryService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation categoryPut
   */
  static readonly CategoryPutPath = '/category';

  /**
   * TODO: Pending move definitions to ref schemas.
   *
   * Update category
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryPut$Response(params: {
    body: {
'uuid'?: string;
'order_number'?: number;
'showed'?: number;
'name'?: string;
'description'?: string;
}
  }): Observable<StrictHttpResponse<{
'success'?: boolean;
}>> {

    const rb = new RequestBuilder(this.rootUrl, CategoryService.CategoryPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'success'?: boolean;
        }>;
      })
    );
  }

  /**
   * TODO: Pending move definitions to ref schemas.
   *
   * Update category
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categoryPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryPut(params: {
    body: {
'uuid'?: string;
'order_number'?: number;
'showed'?: number;
'name'?: string;
'description'?: string;
}
  }): Observable<{
'success'?: boolean;
}> {

    return this.categoryPut$Response(params).pipe(
      map((r: StrictHttpResponse<{
'success'?: boolean;
}>) => r.body as {
'success'?: boolean;
})
    );
  }

  /**
   * Path part for operation categoryGetAll
   */
  static readonly CategoryGetAllPath = '/category';

  /**
   * Get all categorys
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryGetAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryGetAll$Response(params: {
    body: {
'filters'?: Array<{
'filter'?: string;
'value'?: string;
}>;
}
  }): Observable<StrictHttpResponse<CategoryGetAllResp>> {

    const rb = new RequestBuilder(this.rootUrl, CategoryService.CategoryGetAllPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategoryGetAllResp>;
      })
    );
  }

  /**
   * Get all categorys
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categoryGetAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryGetAll(params: {
    body: {
'filters'?: Array<{
'filter'?: string;
'value'?: string;
}>;
}
  }): Observable<CategoryGetAllResp> {

    return this.categoryGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<CategoryGetAllResp>) => r.body as CategoryGetAllResp)
    );
  }

  /**
   * Path part for operation categoryGet
   */
  static readonly CategoryGetPath = '/category/{uuid}';

  /**
   * TODO: Pending move definitions to ref schemas.
   *
   * Get information about a category
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryGet$Response(params: {

    /**
     * category uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<{
'id'?: number;
'uuid'?: string;
'order_number'?: number;
'showed'?: number;
'name'?: string;
'description'?: string;
}>> {

    const rb = new RequestBuilder(this.rootUrl, CategoryService.CategoryGetPath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'id'?: number;
        'uuid'?: string;
        'order_number'?: number;
        'showed'?: number;
        'name'?: string;
        'description'?: string;
        }>;
      })
    );
  }

  /**
   * TODO: Pending move definitions to ref schemas.
   *
   * Get information about a category
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categoryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryGet(params: {

    /**
     * category uuid
     */
    uuid: string;
  }): Observable<{
'id'?: number;
'uuid'?: string;
'order_number'?: number;
'showed'?: number;
'name'?: string;
'description'?: string;
}> {

    return this.categoryGet$Response(params).pipe(
      map((r: StrictHttpResponse<{
'id'?: number;
'uuid'?: string;
'order_number'?: number;
'showed'?: number;
'name'?: string;
'description'?: string;
}>) => r.body as {
'id'?: number;
'uuid'?: string;
'order_number'?: number;
'showed'?: number;
'name'?: string;
'description'?: string;
})
    );
  }

  /**
   * Path part for operation categoryDelete
   */
  static readonly CategoryDeletePath = '/category/{uuid}';

  /**
   * TODO: Pending move definitions to ref schemas.
   *
   * Delete category
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryDelete$Response(params: {
    body: {
'uuid'?: string;
}
  }): Observable<StrictHttpResponse<{
'success'?: boolean;
}>> {

    const rb = new RequestBuilder(this.rootUrl, CategoryService.CategoryDeletePath, 'delete');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'success'?: boolean;
        }>;
      })
    );
  }

  /**
   * TODO: Pending move definitions to ref schemas.
   *
   * Delete category
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categoryDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categoryDelete(params: {
    body: {
'uuid'?: string;
}
  }): Observable<{
'success'?: boolean;
}> {

    return this.categoryDelete$Response(params).pipe(
      map((r: StrictHttpResponse<{
'success'?: boolean;
}>) => r.body as {
'success'?: boolean;
})
    );
  }

  /**
   * Path part for operation categoryPublicGet
   */
  static readonly CategoryPublicGetPath = '/category/get-public';

  /**
   * Get categories public
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categoryPublicGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryPublicGet$Response(params?: {
  }): Observable<StrictHttpResponse<CategoryPublicGetResp>> {

    const rb = new RequestBuilder(this.rootUrl, CategoryService.CategoryPublicGetPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategoryPublicGetResp>;
      })
    );
  }

  /**
   * Get categories public
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categoryPublicGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categoryPublicGet(params?: {
  }): Observable<CategoryPublicGetResp> {

    return this.categoryPublicGet$Response(params).pipe(
      map((r: StrictHttpResponse<CategoryPublicGetResp>) => r.body as CategoryPublicGetResp)
    );
  }

}
